"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dungThongBaoLoiTiengViet = dungThongBaoLoiTiengViet;
const zod_1 = require("zod");
/**
 * Chuyển thông báo lỗi mặc định của zod sang tiếng Việt.
 *
 * Vì sao cần: toàn bộ thông báo lỗi của hệ đều là tiếng Việt và hiển thị trực
 * tiếp cho người dùng (xem AllExceptionsFilter), riêng lỗi kiểm tra dữ liệu lại
 * ra tiếng Anh kiểu "String must contain at least 6 character(s)" — lẫn hai thứ
 * tiếng trong cùng một màn hình.
 *
 * Gọi MỘT LẦN lúc khởi động (apps/api/src/main.ts). Dùng chung được cho web.
 */
function dungThongBaoLoiTiengViet() {
    zod_1.z.setErrorMap((issue, ctx) => {
        switch (issue.code) {
            case zod_1.z.ZodIssueCode.invalid_type:
                if (issue.received === "undefined")
                    return { message: "Thiếu thông tin bắt buộc" };
                return { message: `Sai kiểu dữ liệu: cần ${dichKieu(issue.expected)}` };
            case zod_1.z.ZodIssueCode.too_small:
                if (issue.type === "string")
                    return {
                        message: issue.minimum === 1
                            ? "Không được để trống"
                            : `Phải có ít nhất ${issue.minimum} ký tự`,
                    };
                if (issue.type === "array")
                    return { message: `Phải có ít nhất ${issue.minimum} phần tử` };
                return { message: `Giá trị phải từ ${issue.minimum} trở lên` };
            case zod_1.z.ZodIssueCode.too_big:
                if (issue.type === "string")
                    return { message: `Không được vượt quá ${issue.maximum} ký tự` };
                if (issue.type === "array")
                    return { message: `Không được vượt quá ${issue.maximum} phần tử` };
                return { message: `Giá trị không được vượt quá ${issue.maximum}` };
            case zod_1.z.ZodIssueCode.invalid_enum_value:
                return { message: `Giá trị không nằm trong danh sách cho phép` };
            case zod_1.z.ZodIssueCode.invalid_string:
                if (issue.validation === "email")
                    return { message: "Email không đúng định dạng" };
                if (issue.validation === "url")
                    return { message: "Đường dẫn không đúng định dạng" };
                return { message: "Giá trị không đúng định dạng" };
            case zod_1.z.ZodIssueCode.unrecognized_keys:
                return { message: `Có trường không được phép: ${issue.keys.join(", ")}` };
            default:
                // Giữ nguyên thông báo mặc định cho các trường hợp còn lại
                return { message: ctx.defaultError };
        }
    });
}
function dichKieu(t) {
    const b = {
        string: "chuỗi ký tự",
        number: "số",
        boolean: "đúng/sai",
        array: "danh sách",
        object: "đối tượng",
        date: "ngày",
    };
    return b[t] ?? t;
}
